module.exports = __webpack_public_path__ + "assets/img/tables.5132c331.svg";